import TypographyParagraph from '../../typography/TypographyParagraph'
import { Tooltip, TooltipRefProps } from 'react-tooltip'
import { useRef } from 'react'

export default function RevokeTemplate({ revoke }: { revoke: any }) {
	const tooltipCopyDescription = useRef<TooltipRefProps>(null)
	// const tooltipCopyoriginalAttestationIPFSCID = useRef<TooltipRefProps>(null);

	return (
		<>
			{revoke.properties.description && (
				<div
					id="title"
					className="flex flex-row justify-between border-b border-textInactiveLight p-4 hover:bg-uiSecondaryLight dark:border-textInactiveDark dark:hover:bg-uiSecondaryDark"
					onClick={() => {
						navigator.clipboard.writeText(revoke.properties.description)
						tooltipCopyDescription.current?.open({
							anchorSelect: '#title',
							content: 'Copied!',
						})
						setTimeout(() => {
							tooltipCopyDescription.current?.close()
						}, 2000)
					}}
				>
					<Tooltip imperativeModeOnly ref={tooltipCopyDescription} />
					<TypographyParagraph
						size="medium"
						additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
					>
						Description:
					</TypographyParagraph>
					<TypographyParagraph
						size="medium"
						additionalClasses="ml-2 text-textPrimaryLight dark:text-textPrimaryDark"
					>
						{revoke.properties.description}
					</TypographyParagraph>
				</div>
			)}
			{/* {revoke.properties.originalAttestationIPFSCID &&
                <div id="signature" className="flex flex-row p-4 hover:bg-uiSecondaryLight dark:hover:bg-uiSecondaryDark"
                    onClick={() => {
                        navigator.clipboard.writeText(revoke.properties.originalAttestationIPFSCID);
                        tooltipCopyoriginalAttestationIPFSCID.current?.open({
                            anchorSelect: '#signature',
                            content: 'Copied!',
                        });
                        setTimeout(() => {
                            tooltipCopyoriginalAttestationIPFSCID.current?.close();
                        }, 2000);
                    }}>
                    <Tooltip imperativeModeOnly ref={tooltipCopyoriginalAttestationIPFSCID} />
                    <TypographyParagraph size="medium" additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark">Original Attestation Signature:</TypographyParagraph>
                    <TypographyParagraph size="medium" additionalClasses="ml-2 text-textPrimaryLight dark:text-textPrimaryDark break-all">{revoke.properties.originalAttestationIPFSCID}</TypographyParagraph>
                </div>
            } */}
		</>
	)
}
